// extracted by mini-css-extract-plugin
module.exports = {"vUiHue":"#ddd","wrapper":"TiledSelectionHorizontal__wrapper___-kTdZ","empty":"TiledSelectionHorizontal__empty___6Uxog"};